module.exports = __webpack_public_path__ + "img/blog4.a0b8a866.png";